import { render, staticRenderFns } from "./DeviceTaskList.vue?vue&type=template&id=b55e05ae"
import script from "./DeviceTaskList.vue?vue&type=script&lang=js"
export * from "./DeviceTaskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports